export const APIURL = "https://vrajpath.com/api"; 